import OrganisationTypes from './organisation.types';

// Create Organisation Actions
export const createOrganisationStart = (data: any) => ({
	type: OrganisationTypes.CREATE_ORGANISATION_START,
	payload: data,
});

export const createOrganisationSuccess = (data: any) => ({
	type: OrganisationTypes.CREATE_ORGANISATION_SUCCESS,
	payload: data,
});

export const createOrganisationFailure = (error: unknown) => ({
	type: OrganisationTypes.CREATE_ORGANISATION_FAILURE,
	payload: error,
});

// Update Organisation Actions
export const updateOrganisationStart = (data: any) => ({
	type: OrganisationTypes.UPDATE_ORGANISATION_START,
	payload: data,
});

export const updateOrganisationSuccess = (data: any) => ({
	type: OrganisationTypes.UPDATE_ORGANISATION_SUCCESS,
	payload: data,
});

export const updateOrganisationFailure = (error: unknown) => ({
	type: OrganisationTypes.UPDATE_ORGANISATION_FAILURE,
	payload: error,
});

// Get Organisation Actions
export const getOrganisationStart = (data: any) => ({
	type: OrganisationTypes.GET_ORGANISATION_START,
	payload: data,
});

export const getOrganisationSuccess = (data: any) => ({
	type: OrganisationTypes.GET_ORGANISATION_SUCCESS,
	payload: data,
});

export const getOrganisationFailure = (error: unknown) => ({
	type: OrganisationTypes.GET_ORGANISATION_FAILURE,
	payload: error,
});

// Get All Organisations Actions
export const getAllOrganisationsStart = (data: any) => ({
	type: OrganisationTypes.GET_ALL_ORGANISATIONS_START,
	payload: data,
});

export const getAllOrganisationsSuccess = (data: any) => ({
	type: OrganisationTypes.GET_ALL_ORGANISATIONS_SUCCESS,
	payload: data,
});

export const getAllOrganisationsFailure = (error: unknown) => ({
	type: OrganisationTypes.GET_ALL_ORGANISATIONS_FAILURE,
	payload: error,
});

// Update Organisation Status Actions
export const updateOrganisationStatusStart = (data: any) => ({
	type: OrganisationTypes.UPDATE_ORGANISATION_STATUS_START,
	payload: data,
});

export const updateOrganisationStatusSuccess = (data: any) => ({
	type: OrganisationTypes.UPDATE_ORGANISATION_STATUS_SUCCESS,
	payload: data,
});

export const updateOrganisationStatusFailure = (error: unknown) => ({
	type: OrganisationTypes.UPDATE_ORGANISATION_STATUS_FAILURE,
	payload: error,
});

// Response Management Actions
export const organisationResponseChanged = () => ({
	type: OrganisationTypes.ORGANISATION_RESPONSE_CHANGED,
});

export const organisationResponseRestStart = () => ({
	type: OrganisationTypes.ORGANISATION_RESPONSE_REST_START,
});
